import { render, staticRenderFns } from "./marketingActivity.vue?vue&type=template&id=c995211e&scoped=true&"
import script from "./marketingActivity.vue?vue&type=script&lang=js&"
export * from "./marketingActivity.vue?vue&type=script&lang=js&"
import style0 from "./marketingActivity.vue?vue&type=style&index=0&id=c995211e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c995211e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c995211e')) {
      api.createRecord('c995211e', component.options)
    } else {
      api.reload('c995211e', component.options)
    }
    module.hot.accept("./marketingActivity.vue?vue&type=template&id=c995211e&scoped=true&", function () {
      api.rerender('c995211e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingActivity/marketingActivity.vue"
export default component.exports